// Generated by CoffeeScript 2.7.0
var Admin__ResponsesController;

import MessageNavActions from './concerns/message_nav_actions.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import ResponsesTable from 'trunks/vue/admin/compositions/datable_table/responses_table.js';

import {
  NewDataclipsNavigation
} from 'trunks/vue/admin/compositions/dataclip/navigation.js';

export default Admin__ResponsesController = (function() {
  class Admin__ResponsesController extends Skylark.App.BaseController {
    index() {
      var dataclipable, main_el, responseable_gid, responses_table_el;
      this.__toggleNavMenu();
      main_el = DomMaster.find('main');
      responses_table_el = main_el.find('#js_responses_container');
      dataclipable = _.clone(this.getVars('dataclipable'));
      responseable_gid = new Skylark.Libs.GlobalID(dataclipable.gid);
      this._setupDataclipsNavigation(null, dataclipable);
      return new ResponsesTable({
        el: responses_table_el.node,
        propsData: {
          fieldable: new Skylark.App.Model.Form(dataclipable),
          datableGID: responseable_gid,
          preserveredFilters: typeof dataclip !== "undefined" && dataclip !== null ? dataclip.conditions : void 0,
          totalRecordCount: this.getVars('total_count')
        }
      });
    }

    _setupDataclipsNavigation(dataclip, dataclipable) {
      var options, ref;
      if ((ref = this.constructor.$dataclipsNavigation) != null ? ref.$el.offsetParent : void 0) {
        return;
      }
      options = {
        responseableManaged: this.getVars('responseableManaged')
      };
      return this.constructor.$dataclipsNavigation = NewDataclipsNavigation(dataclip, dataclipable, options);
    }

  };

  Admin__ResponsesController.include(MessageNavActions, ToggleNavMenuAction);

  return Admin__ResponsesController;

}).call(this);
